import { Input } from "@fluentui/react-components";
import { FluentField } from "./Fluent-Field";
import PropTypes from "prop-types";
import "./fluent-overide.scss";

export const FluentInput = ({
  label,
  disabled,
  size,
  type,
  placeholder,
  onChange,
  defaultValue,
  validationMessage,
  required,
  onBlur,
  onKeyDown,
  contentAfter,
  contentBefore,
  name,
  componentStyle,
  noKey = false,
  value,
  id,
  min,
}) => {
  return (
    <FluentField
      label={label}
      size={size}
      validationMessage={validationMessage}
      required={required}
    >
      <Input
        name={name}
        value={value !== undefined ? value : undefined}
        defaultValue={value === undefined ? defaultValue : undefined}
        type={type}
        min={min}
        disabled={disabled}
        size={size}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        contentAfter={contentAfter}
        contentBefore={contentBefore}
        key={noKey ? null : value ?? defaultValue}
        className={`fluentInput ${componentStyle}`}
        id={id}
      />
    </FluentField>
  );
};

FluentInput.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  validationMessage: PropTypes.string,
  required: PropTypes.bool,
  contentAfter: PropTypes.object,
  contentBefore: PropTypes.object,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  componentStyle: PropTypes.string,
  onChange: PropTypes.func,
  id: PropTypes.string,
  min: PropTypes.number,
};
